import type { ITableHeadProps } from "@components/organisms/pageTable";
import { TableFilterSearch } from "@components/organisms/pageTable/components/tableFilterSearch";
import { TableHeading } from "@components/organisms/pageTable/components/tableHeading";

export function TableHead({
  headingProps,
  tableFilterSearchProps,
}: ITableHeadProps) {
  return (
    <div>
      <TableHeading {...headingProps} />
      <TableFilterSearch {...tableFilterSearchProps} />
    </div>
  );
}
